import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ContainerCustomFieldValue} from '../container/container.service';
import {Observable, of} from 'rxjs';
import {v7 as uuidv7} from 'uuid';
import {CustomFieldService} from '../custom-field/custom-field.service';

@Injectable({
  providedIn: 'root',
})
export class ContainerCustomFieldService {

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    public updateCustomFieldValues(customFieldValues: ContainerCustomFieldValue[]): Observable<any> {
        const body: { id: string; field: string; value: string; }[] = [];

        if (customFieldValues.length === 0) {
            return of(null); // emits once and completes — forkJoin-safe
        }

        customFieldValues.forEach(customFieldValue => {
            body.push({
                id: uuidv7(),
                field: CustomFieldService.buildIri(customFieldValue.customField),
                value: customFieldValue.value,

            });
        })

        return this.httpClient.put(
            `/containers/${customFieldValues[0].container.id}/values`,
            body,
            {headers: {'Content-Type': 'application/ld+json'}}
        );
    }
}
